import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  changeInterestAnswer,
  getInterestQuestion,
  getInterest,
  finishInterest,
} from '../../../../ducks/respondent'
import styles from './InterestQuestion.module.scss'
import { Tile } from 'components/shared/Tile/Tile'
import SwipePage, { Slider } from 'components/common/SwipePage'
import {
  nextPage,
  previousPage,
  nextUnanswered,
  getQuizPage,
} from 'ducks/router'
import { QuestionContainer } from 'components/shared/QuestionContainer/QuestionContainer'

const selectQuestion = state => {
  const questionProps = getInterestQuestion(null)(state)
  const { totalQuestions, totalAnswers } = getInterest(state)
  const finished = totalQuestions - totalAnswers === 0
  const pageFromUrl = getQuizPage(state).page

  return {
    questions: state.respondent.interest.questions,
    finished,
    totalQuestions,
    totalAnswers,
    pageFromUrl,
    answered: questionProps.value != null,
    reversed: getQuizPage(state).reversed,
    ...questionProps,
  }
}

const InterestQuestion = () => {
  const {
    question,
    finished,
    totalQuestions,
    pageFromUrl,
    answered,
    questions,
    prompt,
    label = 'which number?',
    scale = { 1: 'one', 2: 'two', 3: 'three' },
    value = null,
    reversed,
  } = useSelector(selectQuestion, shallowEqual)
  const dispatch = useDispatch()

  const changeValue = value => {
    dispatch(changeInterestAnswer({ key: question, value }))
    value && dispatch(nextUnanswered())
  }

  if (!questions) {
    return null
  }

  const questionIndex = pageFromUrl + 1

  const tiles = Object.entries(scale).map(([val, label]) => (
    <Tile
      key={val}
      label={label}
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        changeValue(val === String(value) ? null : val)
      }}
      selected={val === value}
    />
  ))

  return (
    <QuestionContainer
      {...{
        questionIndex,
        totalQuestions,
        finished,
        answered,
      }}
      previousPage={() => dispatch(previousPage())}
      nextUnanswered={() => dispatch(nextUnanswered())}
      nextPage={() => dispatch(nextPage())}
      finishTest={() => dispatch(finishInterest())}
      collapse
    >
      <Slider page={prompt} reversed={reversed} slideSpeed={400}>
        <div className={styles.prompt}>{prompt}</div>
      </Slider>

      <SwipePage slideSpeed={400}>
        <div className={styles.swipePage}>
          <div className={styles.statement}>
            {label.charAt(0).toUpperCase() + label.slice(1)}
          </div>
          <div className={styles.tiles}>{tiles}</div>
        </div>
      </SwipePage>
    </QuestionContainer>
  )
}

export default InterestQuestion
